import { useCallback, useEffect } from 'react';

import { useRudderStack } from '@ocx-app/lib/rudderStack/useRudderStack';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { useMembership } from '@ocx/data-membership';
import { useConfiguration } from '@ocx/data-configuration';

import { LoyaltyIdBarcodeScanButton } from './loyalty-id-barcode-scan-button';
import { useLoyaltyIdBarcodeScanActionSheet } from './loyalty-id-barcode-scan-action-sheet';

export const LoyaltyIdBarcodeController = () => {
  const { config } = useConfiguration();
  const { membership } = useMembership();
  const { triggerEvent } = useRudderStack();
  const { open, close } = useLoyaltyIdBarcodeScanActionSheet();

  useEffect(() => {
    return () => {
      close();
    };
  }, [close]);

  const isVisible = config.loyaltyIdBarcode.enabled && !!membership.barcodeIdentifier;

  const handleClick = useCallback(() => {
    if (!membership.barcodeIdentifier) {
      return;
    }

    open({ barcodeValue: membership.barcodeIdentifier });
    triggerEvent('loyalty_id_barcode_modal_opened');
  }, [membership.barcodeIdentifier, open, triggerEvent]);

  if (!isVisible) {
    return null;
  }

  return <LoyaltyIdBarcodeScanButton onClick={handleClick} />;
};
